export default __webpack_public_path__ + "static/media/fixpert.66a2f2c0.jpg";